// extracted by mini-css-extract-plugin
export default {"root":"IconCloseCircle_root__O1N0B"};